export default __webpack_public_path__ + "static/media/appfolio.2c9e171a.png";